module.exports = __webpack_public_path__ + "static/media/archero2_page_area02_img_en@2x.4180e43d.png";